var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoInquiryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1917.68 1854.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:#fff;}.cls-5{opacity:0.16;}.cls-50,.cls-6{opacity:0;}.cls-6{fill:url(#linear-gradient-4);}.cls-51,.cls-7{opacity:0.04;}.cls-7{fill:url(#linear-gradient-5);}.cls-52,.cls-8{opacity:0.07;}.cls-8{fill:url(#linear-gradient-6);}.cls-53,.cls-9{opacity:0.11;}.cls-9{fill:url(#linear-gradient-7);}.cls-10,.cls-54{opacity:0.14;}.cls-10{fill:url(#linear-gradient-8);}.cls-11,.cls-55{opacity:0.18;}.cls-11{fill:url(#linear-gradient-9);}.cls-12,.cls-56{opacity:0.21;}.cls-12{fill:url(#linear-gradient-10);}.cls-13,.cls-57{opacity:0.25;}.cls-13{fill:url(#linear-gradient-11);}.cls-14,.cls-58{opacity:0.29;}.cls-14{fill:url(#linear-gradient-12);}.cls-15,.cls-59{opacity:0.32;}.cls-15{fill:url(#linear-gradient-13);}.cls-16,.cls-60{opacity:0.36;}.cls-16{fill:url(#linear-gradient-14);}.cls-17,.cls-61{opacity:0.39;}.cls-17{fill:url(#linear-gradient-15);}.cls-18,.cls-62{opacity:0.43;}.cls-18{fill:url(#linear-gradient-16);}.cls-19,.cls-63{opacity:0.46;}.cls-19{fill:url(#linear-gradient-17);}.cls-20,.cls-64{opacity:0.5;}.cls-20{fill:url(#linear-gradient-18);}.cls-21,.cls-65{opacity:0.54;}.cls-21{fill:url(#linear-gradient-19);}.cls-22,.cls-66{opacity:0.57;}.cls-22{fill:url(#linear-gradient-20);}.cls-23,.cls-67{opacity:0.61;}.cls-23{fill:url(#linear-gradient-21);}.cls-24,.cls-68{opacity:0.64;}.cls-24{fill:url(#linear-gradient-22);}.cls-25,.cls-69{opacity:0.68;}.cls-25{fill:url(#linear-gradient-23);}.cls-26,.cls-70{opacity:0.71;}.cls-26{fill:url(#linear-gradient-24);}.cls-27,.cls-71{opacity:0.75;}.cls-27{fill:url(#linear-gradient-25);}.cls-28,.cls-72{opacity:0.79;}.cls-28{fill:url(#linear-gradient-26);}.cls-29,.cls-73{opacity:0.82;}.cls-29{fill:url(#linear-gradient-27);}.cls-30,.cls-74{opacity:0.86;}.cls-30{fill:url(#linear-gradient-28);}.cls-31,.cls-75{opacity:0.89;}.cls-31{fill:url(#linear-gradient-29);}.cls-32,.cls-76{opacity:0.93;}.cls-32{fill:url(#linear-gradient-30);}.cls-33,.cls-77{opacity:0.96;}.cls-33{fill:url(#linear-gradient-31);}.cls-34{fill:url(#linear-gradient-32);}.cls-35{fill:url(#linear-gradient-33);}.cls-36{fill:url(#linear-gradient-34);}.cls-37{fill:url(#linear-gradient-35);}.cls-38{fill:url(#linear-gradient-36);}.cls-39{fill:url(#linear-gradient-37);}.cls-40{fill:url(#linear-gradient-38);}.cls-41,.cls-42,.cls-45{fill:none;stroke-linecap:round;stroke-linejoin:round;}.cls-41{stroke:#cecece;}.cls-41,.cls-45{stroke-width:11.84px;}.cls-42,.cls-45{stroke:#70b7f2;}.cls-42{stroke-width:8.88px;}.cls-43{fill:url(#linear-gradient-39);}.cls-44{fill:#d7d7d7;}.cls-46{fill:#cecece;}.cls-47{fill:url(#linear-gradient-40);}.cls-48{fill:url(#linear-gradient-41);}.cls-49{fill:url(#linear-gradient-42);}.cls-50{fill:url(#linear-gradient-43);}.cls-51{fill:url(#linear-gradient-44);}.cls-52{fill:url(#linear-gradient-45);}.cls-53{fill:url(#linear-gradient-46);}.cls-54{fill:url(#linear-gradient-47);}.cls-55{fill:url(#linear-gradient-48);}.cls-56{fill:url(#linear-gradient-49);}.cls-57{fill:url(#linear-gradient-50);}.cls-58{fill:url(#linear-gradient-51);}.cls-59{fill:url(#linear-gradient-52);}.cls-60{fill:url(#linear-gradient-53);}.cls-61{fill:url(#linear-gradient-54);}.cls-62{fill:url(#linear-gradient-55);}.cls-63{fill:url(#linear-gradient-56);}.cls-64{fill:url(#linear-gradient-57);}.cls-65{fill:url(#linear-gradient-58);}.cls-66{fill:url(#linear-gradient-59);}.cls-67{fill:url(#linear-gradient-60);}.cls-68{fill:url(#linear-gradient-61);}.cls-69{fill:url(#linear-gradient-62);}.cls-70{fill:url(#linear-gradient-63);}.cls-71{fill:url(#linear-gradient-64);}.cls-72{fill:url(#linear-gradient-65);}.cls-73{fill:url(#linear-gradient-66);}.cls-74{fill:url(#linear-gradient-67);}.cls-75{fill:url(#linear-gradient-68);}.cls-76{fill:url(#linear-gradient-69);}.cls-77{fill:url(#linear-gradient-70);}.cls-78{fill:url(#linear-gradient-71);}.cls-79{isolation:isolate;}.cls-80{fill:url(#linear-gradient-72);}.cls-81{fill:url(#linear-gradient-73);}.cls-82{fill:url(#linear-gradient-74);}.cls-83{fill:url(#linear-gradient-75);}.cls-84{fill:url(#linear-gradient-76);}.cls-85{fill:url(#linear-gradient-77);}.cls-86{fill:url(#linear-gradient-78);}.cls-87{opacity:0.64;fill:url(#linear-gradient-79);}.cls-88{fill:url(#linear-gradient-80);}.cls-89{fill:url(#linear-gradient-81);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 1475.45,
    x2: 1703.77,
    y2: 1475.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1480.24,
    y1: 1470.99,
    x2: 224.2,
    y2: 1470.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdfdfd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0,
    y1: 1412.86,
    x2: 1703.77,
    y2: 1412.86,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 261.68,
    y1: 1330.67,
    x2: 814.27,
    y2: 1330.67,
    gradientTransform: "matrix(1.55, 0, 0, 1.9, 169.9, -962.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#313031"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 271.55,
    y1: 1330.33,
    x2: 812.79,
    y2: 1330.33,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 281.42,
    y1: 1329.99,
    x2: 811.3,
    y2: 1329.99,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 291.28,
    y1: 1329.65,
    x2: 809.81,
    y2: 1329.65,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 301.15,
    y1: 1329.3,
    x2: 808.33,
    y2: 1329.3,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 311.02,
    y1: 1328.96,
    x2: 806.84,
    y2: 1328.96,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 320.89,
    y1: 1328.62,
    x2: 805.35,
    y2: 1328.62,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 330.76,
    y1: 1328.28,
    x2: 803.86,
    y2: 1328.28,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 340.62,
    y1: 1327.94,
    x2: 802.38,
    y2: 1327.94,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 350.49,
    y1: 1327.59,
    x2: 800.89,
    y2: 1327.59,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 360.36,
    y1: 1327.25,
    x2: 799.4,
    y2: 1327.25,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 370.23,
    y1: 1326.91,
    x2: 797.92,
    y2: 1326.91,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 380.09,
    y1: 1326.57,
    x2: 796.43,
    y2: 1326.57,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 389.96,
    y1: 1326.22,
    x2: 794.94,
    y2: 1326.22,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 399.83,
    y1: 1325.88,
    x2: 793.45,
    y2: 1325.88,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 409.7,
    y1: 1325.54,
    x2: 791.97,
    y2: 1325.54,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 419.56,
    y1: 1325.2,
    x2: 790.48,
    y2: 1325.2,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 429.43,
    y1: 1324.85,
    x2: 788.99,
    y2: 1324.85,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 439.3,
    y1: 1324.51,
    x2: 787.51,
    y2: 1324.51,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 449.17,
    y1: 1324.17,
    x2: 786.02,
    y2: 1324.17,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 459.04,
    y1: 1323.83,
    x2: 784.53,
    y2: 1323.83,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 468.9,
    y1: 1323.49,
    x2: 783.04,
    y2: 1323.49,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 478.77,
    y1: 1323.14,
    x2: 781.56,
    y2: 1323.14,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 488.64,
    y1: 1322.8,
    x2: 780.07,
    y2: 1322.8,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 498.51,
    y1: 1322.46,
    x2: 778.58,
    y2: 1322.46,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 508.37,
    y1: 1322.12,
    x2: 777.1,
    y2: 1322.12,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 518.24,
    y1: 1321.77,
    x2: 775.61,
    y2: 1321.77,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 528.11,
    y1: 1321.43,
    x2: 774.12,
    y2: 1321.43,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 537.98,
    y1: 1321.09,
    x2: 772.63,
    y2: 1321.09,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 785.85,
    y1: 132.15,
    x2: 1015.31,
    y2: 882.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#094eb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40b7f0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 780.64,
    y1: 1346.67,
    x2: 1131.62,
    y2: 369.62,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 879.43,
    y1: 458.27,
    x2: 981.41,
    y2: 1430.77,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 740.13,
    y1: 1252.89,
    x2: 1226.72,
    y2: 346.83,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 886.81,
    y1: 212.23,
    x2: 1115.67,
    y2: 203.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 1097.12,
    y1: 244.31,
    x2: 908.22,
    y2: 149.39,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 1185.29,
    y1: 786.99,
    x2: 1200.17,
    y2: 594.84,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 1195.95,
    y1: 804.01,
    x2: 1133.34,
    y2: 795.66,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 1269.01,
    y1: 801.03,
    x2: 1201.4,
    y2: 778.07,
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 1143.21,
    y1: 2788.29,
    x2: 1190.22,
    y2: 2788.29,
    gradientTransform: "matrix(0.48, 1.01, -0.62, 0.79, 2322.05, -2718.71)",
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -1988.69,
    y1: 1209.76,
    x2: -1436.09,
    y2: 1209.76,
    gradientTransform: "matrix(0.99, 0, 0, 1.22, 2023.41, -183.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -1978.82,
    y1: 1209.42,
    x2: -1437.58,
    y2: 1209.42,
    gradientTransform: "matrix(0.99, 0, 0, 1.22, 2023.41, -183.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -1968.95,
    y1: 1209.08,
    x2: -1439.06,
    y2: 1209.08,
    gradientTransform: "matrix(0.99, 0, 0, 1.22, 2023.41, -183.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -1959.09,
    y1: 1208.73,
    x2: -1440.55,
    y2: 1208.73,
    gradientTransform: "matrix(0.99, 0, 0, 1.22, 2023.41, -183.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -1949.22,
    y1: 1208.39,
    x2: -1442.04,
    y2: 1208.39,
    gradientTransform: "matrix(0.99, 0, 0, 1.22, 2023.41, -183.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -1939.35,
    y1: 1208.05,
    x2: -1443.53,
    y2: 1208.05,
    gradientTransform: "matrix(0.99, 0, 0, 1.22, 2023.41, -183.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -1929.48,
    y1: 1207.71,
    x2: -1445.01,
    y2: 1207.71,
    gradientTransform: "matrix(0.99, 0, 0, 1.22, 2023.41, -183.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -1919.62,
    y1: 1207.36,
    x2: -1446.5,
    y2: 1207.36,
    gradientTransform: "matrix(0.99, 0, 0, 1.22, 2023.41, -183.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -1909.75,
    y1: 1207.02,
    x2: -1447.99,
    y2: 1207.02,
    gradientTransform: "matrix(0.99, 0, 0, 1.22, 2023.41, -183.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -1899.88,
    y1: 1206.68,
    x2: -1449.48,
    y2: 1206.68,
    gradientTransform: "matrix(0.99, 0, 0, 1.22, 2023.41, -183.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -1890.01,
    y1: 1206.34,
    x2: -1450.96,
    y2: 1206.34,
    gradientTransform: "matrix(0.99, 0, 0, 1.22, 2023.41, -183.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -1880.14,
    y1: 1206,
    x2: -1452.45,
    y2: 1206,
    gradientTransform: "matrix(0.99, 0, 0, 1.22, 2023.41, -183.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -1870.28,
    y1: 1205.65,
    x2: -1453.94,
    y2: 1205.65,
    gradientTransform: "matrix(0.99, 0, 0, 1.22, 2023.41, -183.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -1860.41,
    y1: 1205.31,
    x2: -1455.42,
    y2: 1205.31,
    gradientTransform: "matrix(0.99, 0, 0, 1.22, 2023.41, -183.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -1850.54,
    y1: 1204.97,
    x2: -1456.91,
    y2: 1204.97,
    gradientTransform: "matrix(0.99, 0, 0, 1.22, 2023.41, -183.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: -1840.67,
    y1: 1204.63,
    x2: -1458.4,
    y2: 1204.63,
    gradientTransform: "matrix(0.99, 0, 0, 1.22, 2023.41, -183.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -1830.8,
    y1: 1204.28,
    x2: -1459.89,
    y2: 1204.28,
    gradientTransform: "matrix(0.99, 0, 0, 1.22, 2023.41, -183.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: -1820.94,
    y1: 1203.94,
    x2: -1461.37,
    y2: 1203.94,
    gradientTransform: "matrix(0.99, 0, 0, 1.22, 2023.41, -183.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -1811.07,
    y1: 1203.6,
    x2: -1462.86,
    y2: 1203.6,
    gradientTransform: "matrix(0.99, 0, 0, 1.22, 2023.41, -183.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -1801.2,
    y1: 1203.26,
    x2: -1464.35,
    y2: 1203.26,
    gradientTransform: "matrix(0.99, 0, 0, 1.22, 2023.41, -183.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: -1791.33,
    y1: 1202.91,
    x2: -1465.83,
    y2: 1202.91,
    gradientTransform: "matrix(0.99, 0, 0, 1.22, 2023.41, -183.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -1781.47,
    y1: 1202.57,
    x2: -1467.32,
    y2: 1202.57,
    gradientTransform: "matrix(0.99, 0, 0, 1.22, 2023.41, -183.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -1771.6,
    y1: 1202.23,
    x2: -1468.81,
    y2: 1202.23,
    gradientTransform: "matrix(0.99, 0, 0, 1.22, 2023.41, -183.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: -1761.73,
    y1: 1201.89,
    x2: -1470.3,
    y2: 1201.89,
    gradientTransform: "matrix(0.99, 0, 0, 1.22, 2023.41, -183.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: -1751.86,
    y1: 1201.55,
    x2: -1471.78,
    y2: 1201.55,
    gradientTransform: "matrix(0.99, 0, 0, 1.22, 2023.41, -183.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: -1741.99,
    y1: 1201.2,
    x2: -1473.27,
    y2: 1201.2,
    gradientTransform: "matrix(0.99, 0, 0, 1.22, 2023.41, -183.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: -1732.13,
    y1: 1200.86,
    x2: -1474.76,
    y2: 1200.86,
    gradientTransform: "matrix(0.99, 0, 0, 1.22, 2023.41, -183.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: -1722.26,
    y1: 1200.52,
    x2: -1476.24,
    y2: 1200.52,
    gradientTransform: "matrix(0.99, 0, 0, 1.22, 2023.41, -183.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: -1712.39,
    y1: 1200.18,
    x2: -1477.73,
    y2: 1200.18,
    gradientTransform: "matrix(0.99, 0, 0, 1.22, 2023.41, -183.4)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 10438.56,
    y1: 1084.41,
    x2: 10290.74,
    y2: 1084.41,
    gradientTransform: "matrix(-1, 0, 0, 1, 10833.42, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7b6b6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 10305.91,
    y1: 860.17,
    x2: 10450.99,
    y2: 860.17,
    xlinkHref: "#linear-gradient-72"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 10339.12,
    y1: 757.25,
    x2: 10417.78,
    y2: 757.25,
    gradientTransform: "matrix(-1, 0, 0, 1, 10833.42, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 10339.12,
    y1: 643,
    x2: 10417.78,
    y2: 643,
    xlinkHref: "#linear-gradient-72"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 10565.45,
    y1: 107.76,
    x2: 10410.84,
    y2: 512.13,
    xlinkHref: "#linear-gradient-72"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 10451.8,
    y1: 64.31,
    x2: 10297.19,
    y2: 468.67,
    xlinkHref: "#linear-gradient-72"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 10206.57,
    y1: 415.06,
    x2: 10645.13,
    y2: 415.06,
    gradientTransform: "matrix(-1, 0, 0, 1, 10833.42, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 10246.87,
    y1: 406.17,
    x2: 10574.97,
    y2: 406.17,
    gradientTransform: "matrix(-1, 0, 0, 1, 10833.42, 0)",
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 1595.74,
    y1: 637.67,
    x2: 1844.49,
    y2: 1142.02,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 1603.13,
    y1: 1053.47,
    x2: 1666.93,
    y2: 655.35,
    xlinkHref: "#linear-gradient-37"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 851.88,
    cy: 1475.45,
    rx: 851.88,
    ry: 378.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 851.88,
    cy: 1470.99,
    rx: 851.88,
    ry: 378.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 851.88,
    cy: 1412.86,
    rx: 851.88,
    ry: 378.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M851.88,1779.79c-466,0-844.6-166.39-851.71-372.84-.07,2-.17,3.93-.17,5.91C0,1622,381.4,1791.61,851.88,1791.61s851.89-169.57,851.89-378.75c0-2-.11-3.94-.17-5.91C1696.48,1613.4,1317.92,1779.79,851.88,1779.79Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 1001.62,
    cy: 1569.25,
    rx: 427.29,
    ry: 79.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1008.1,
    cy: 1568.6,
    rx: 418.51,
    ry: 77.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 1014.58,
    cy: 1567.95,
    rx: 409.73,
    ry: 76.23
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 1021.06,
    cy: 1567.3,
    rx: 400.95,
    ry: 74.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 1027.54,
    cy: 1566.65,
    rx: 392.17,
    ry: 72.96
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 1034.02,
    cy: 1566,
    rx: 383.39,
    ry: 71.33
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 1040.5,
    cy: 1565.35,
    rx: 374.61,
    ry: 69.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 1046.98,
    cy: 1564.7,
    rx: 365.83,
    ry: 68.06
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 1053.46,
    cy: 1564.04,
    rx: 357.05,
    ry: 66.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 1059.94,
    cy: 1563.39,
    rx: 348.27,
    ry: 64.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 1066.42,
    cy: 1562.74,
    rx: 339.49,
    ry: 63.16
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 1072.9,
    cy: 1562.09,
    rx: 330.71,
    ry: 61.53
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 1079.38,
    cy: 1561.44,
    rx: 321.93,
    ry: 59.89
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 1085.86,
    cy: 1560.79,
    rx: 313.15,
    ry: 58.26
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 1092.34,
    cy: 1560.14,
    rx: 304.37,
    ry: 56.63
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 1098.82,
    cy: 1559.49,
    rx: 295.59,
    ry: 54.99
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 1105.3,
    cy: 1558.84,
    rx: 286.81,
    ry: 53.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 1111.78,
    cy: 1558.18,
    rx: 278.03,
    ry: 51.73
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 1118.26,
    cy: 1557.53,
    rx: 269.25,
    ry: 50.09
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 1124.74,
    cy: 1556.88,
    rx: 260.47,
    ry: 48.46
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-26",
    cx: 1131.22,
    cy: 1556.23,
    rx: 251.69,
    ry: 46.83
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 1137.7,
    cy: 1555.58,
    rx: 242.91,
    ry: 45.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-28",
    cx: 1144.18,
    cy: 1554.93,
    rx: 234.13,
    ry: 43.56
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-29",
    cx: 1150.66,
    cy: 1554.28,
    rx: 225.35,
    ry: 41.93
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 1157.15,
    cy: 1553.63,
    rx: 216.57,
    ry: 40.29
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-31",
    cx: 1163.63,
    cy: 1552.98,
    rx: 207.79,
    ry: 38.66
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-32",
    cx: 1170.11,
    cy: 1552.32,
    rx: 199.01,
    ry: 37.03
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-33",
    cx: 1176.59,
    cy: 1551.67,
    rx: 190.23,
    ry: 35.39
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-34",
    cx: 1183.07,
    cy: 1551.02,
    rx: 181.45,
    ry: 33.76
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M669.62,1228.86l622.06,358.39c32.64,18.8,73.39-4.75,73.39-42.42V459.8a116.59,116.59,0,0,0-58.38-101l-609.3-351c-38.23-22-86,5.57-86,49.69V1128.16A116.22,116.22,0,0,0,669.62,1228.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M655.06,1237.76l622.06,358.39c32.64,18.8,73.39-4.75,73.39-42.42V468.7a116.59,116.59,0,0,0-58.38-101l-609.3-351c-38.23-22-86,5.57-86,49.69V1137.06A116.22,116.22,0,0,0,655.06,1237.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1315.6,1560.14a14.74,14.74,0,0,1-3.2,4.62,16.06,16.06,0,0,1-10.89,4.49,16.7,16.7,0,0,1-7.7-2.13l-622-358.44a82.91,82.91,0,0,1-41.32-71.61V66.37a23.42,23.42,0,0,1,19.3-23.32A22.89,22.89,0,0,0,645,57.38V1128.07a82.8,82.8,0,0,0,41.43,71.62l622.06,358.44A17.48,17.48,0,0,0,1315.6,1560.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1316.9,468.73v1085a15.78,15.78,0,0,1-1.3,6.39,17.48,17.48,0,0,1-7.11-2L686.43,1199.69A82.8,82.8,0,0,1,645,1128.07V57.38a22.89,22.89,0,0,1,4.74-14.33,14.35,14.35,0,0,1,4.5-.59,22.79,22.79,0,0,1,11.84,3.31l609.27,351A83.24,83.24,0,0,1,1316.9,468.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1071.54,203.45l-26.21-15.12c-1.71-24.19-20.83-54.15-44.42-68.51-24.57-15-44.48-7.26-44.71,17.12l-14.53-8.38a31,31,0,0,0-46.47,26.85v25A19.2,19.2,0,0,0,904.8,197l179,103.2a9.11,9.11,0,0,0,13.67-7.9v-44A51.78,51.78,0,0,0,1071.54,203.45Zm-70.63-16.16c-12.55-7.64-22.72-24-22.72-36.55s10.17-16.53,22.72-8.89,22.72,24,22.72,36.55S1013.46,194.93,1000.91,187.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M1063.46,206.28l-26.22-15.11c-1.7-24.2-20.82-54.15-44.41-68.51-24.58-15-44.48-7.26-44.71,17.12l-14.53-8.38a31,31,0,0,0-46.48,26.85v25a19.2,19.2,0,0,0,9.61,16.62L1075.7,303a9.13,9.13,0,0,0,13.68-7.9v-44A51.78,51.78,0,0,0,1063.46,206.28Zm-70.63-16.15c-12.56-7.64-22.73-24-22.73-36.56s10.17-16.53,22.73-8.89,22.72,24,22.72,36.56S1005.38,197.77,992.83,190.13Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: 843.32,
    y1: 378.88,
    x2: 1028.84,
    y2: 486.01
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "1097.46 512.21 1282.97 619.35 1282.97 934.42 1097.46 827.28 1097.46 512.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "1114.23 817.6 1114.23 541.27 1266.2 629.04 1266.2 905.36 1114.23 817.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "693.38 1089.51 693.38 716.73 922.41 849 922.41 1221.77 693.38 1089.51"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-45",
    x1: 708.89,
    y1: 167.4,
    x2: 894.4,
    y2: 274.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: 708.89,
    y1: 209.64,
    x2: 978.19,
    y2: 365.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: 843.32,
    y1: 425.02,
    x2: 1028.84,
    y2: 532.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: 843.32,
    y1: 471.16,
    x2: 1028.84,
    y2: 578.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: 708.89,
    y1: 439.87,
    x2: 1028.84,
    y2: 624.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: 708.89,
    y1: 486.01,
    x2: 1028.84,
    y2: 670.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: 708.89,
    y1: 532.15,
    x2: 1028.84,
    y2: 716.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: 708.89,
    y1: 578.3,
    x2: 1028.84,
    y2: 762.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: 708.89,
    y1: 624.44,
    x2: 1028.84,
    y2: 809.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: 963.02,
    y1: 889.01,
    x2: 1282.97,
    y2: 1073.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: 963.02,
    y1: 935.16,
    x2: 1282.97,
    y2: 1119.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: 963.02,
    y1: 981.3,
    x2: 1282.97,
    y2: 1165.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: 963.02,
    y1: 1027.44,
    x2: 1282.97,
    y2: 1212.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: 963.02,
    y1: 1073.59,
    x2: 1282.97,
    y2: 1258.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: 963.02,
    y1: 1179.8,
    x2: 1282.97,
    y2: 1364.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-41",
    x1: 963.02,
    y1: 1225.95,
    x2: 1282.97,
    y2: 1410.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M824.73,373.06l-22.79,80.5-11.88-7.38-20.67-86.31L750.23,421.4,738,413.82,714,304.19l12.31,7.66,19,88.5,20.09-64.22,9.65,6,21.65,90.18,17.65-65.74Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "1114.23 817.6 1170.87 733.77 1209.7 872.73 1114.23 817.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "1266.2 905.36 1231.89 683.14 1174.57 852.44 1266.2 905.36"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-49",
    cx: 1166.71,
    cy: 656.85,
    rx: 18.35,
    ry: 30.11,
    transform: "translate(-157.13 857.12) rotate(-37.98)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-50",
    cx: 319.52,
    cy: 1297.11,
    rx: 274.89,
    ry: 51.14
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-51",
    cx: 323.68,
    cy: 1296.69,
    rx: 269.24,
    ry: 50.09
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-52",
    cx: 327.85,
    cy: 1296.27,
    rx: 263.59,
    ry: 49.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-53",
    cx: 332.02,
    cy: 1295.85,
    rx: 257.95,
    ry: 47.99
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-54",
    cx: 336.19,
    cy: 1295.43,
    rx: 252.3,
    ry: 46.94
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-55",
    cx: 340.36,
    cy: 1295.02,
    rx: 246.65,
    ry: 45.89
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-56",
    cx: 344.53,
    cy: 1294.6,
    rx: 241,
    ry: 44.84
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-57",
    cx: 348.7,
    cy: 1294.18,
    rx: 235.35,
    ry: 43.79
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-58",
    cx: 352.87,
    cy: 1293.76,
    rx: 229.7,
    ry: 42.74
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-59",
    cx: 357.04,
    cy: 1293.34,
    rx: 224.05,
    ry: 41.69
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-60",
    cx: 361.21,
    cy: 1292.92,
    rx: 218.41,
    ry: 40.63
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-61",
    cx: 365.37,
    cy: 1292.5,
    rx: 212.76,
    ry: 39.58
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-62",
    cx: 369.54,
    cy: 1292.08,
    rx: 207.11,
    ry: 38.53
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-63",
    cx: 373.71,
    cy: 1291.66,
    rx: 201.46,
    ry: 37.48
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-64",
    cx: 377.88,
    cy: 1291.24,
    rx: 195.81,
    ry: 36.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-65",
    cx: 382.05,
    cy: 1290.83,
    rx: 190.16,
    ry: 35.38
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-66",
    cx: 386.22,
    cy: 1290.41,
    rx: 184.51,
    ry: 34.33
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-67",
    cx: 390.39,
    cy: 1289.99,
    rx: 178.87,
    ry: 33.28
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-68",
    cx: 394.56,
    cy: 1289.57,
    rx: 173.22,
    ry: 32.23
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-69",
    cx: 398.73,
    cy: 1289.15,
    rx: 167.57,
    ry: 31.18
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-70",
    cx: 402.9,
    cy: 1288.73,
    rx: 161.92,
    ry: 30.13
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-71",
    cx: 407.07,
    cy: 1288.31,
    rx: 156.27,
    ry: 29.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-72",
    cx: 411.23,
    cy: 1287.89,
    rx: 150.62,
    ry: 28.02
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-73",
    cx: 415.4,
    cy: 1287.47,
    rx: 144.97,
    ry: 26.97
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-74",
    cx: 419.57,
    cy: 1287.06,
    rx: 139.33,
    ry: 25.92
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-75",
    cx: 423.74,
    cy: 1286.64,
    rx: 133.68,
    ry: 24.87
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-76",
    cx: 427.91,
    cy: 1286.22,
    rx: 128.03,
    ry: 23.82
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-77",
    cx: 432.08,
    cy: 1285.8,
    rx: 122.38,
    ry: 22.77
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-78",
    cx: 436.25,
    cy: 1285.38,
    rx: 116.73,
    ry: 21.72
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-79"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M382.61,862.5c.07.76.12,1.52.26,2.27s.3,1.24.47,1.86.36,1.45.62,2.17.49,1.18.74,1.77c.33.75.66,1.51,1.06,2.26.3.54.65,1.07,1,1.61.52.85,1.08,1.7,1.7,2.53.37.49.77,1,1.18,1.47a40.73,40.73,0,0,0,3.07,3.3c.4.39.77.79,1.2,1.18.7.63,1.47,1.23,2.23,1.84s1.31,1.08,2,1.6,1.72,1.17,2.61,1.74,1.78,1.21,2.75,1.78c2.18,1.26,4.48,2.39,6.85,3.46.68.3,1.37.59,2.07.88q2.77,1.17,5.7,2.16c.69.24,1.38.49,2.09.72,1.22.38,2.47.72,3.72,1.06,1,.26,1.9.54,2.87.77,1.31.32,2.64.58,4,.85.93.19,1.84.4,2.78.56q4.06.72,8.24,1.15c.86.09,1.73.15,2.59.22,1.63.13,3.26.25,4.89.33,1.05,0,2.11.06,3.16.08,1.32,0,2.64,0,4,0,1.11,0,2.23,0,3.34-.09s2.45-.11,3.66-.2,2.25-.17,3.37-.28,2.41-.25,3.61-.4,2.18-.29,3.26-.46c1.28-.2,2.56-.43,3.83-.67,1-.19,2-.39,3-.61,1.52-.33,3-.71,4.5-1.1.84-.22,1.68-.43,2.5-.67,2.66-.78,5.26-1.65,7.78-2.63,1.25-.49,2.46-1,3.67-1.56.62-.28,1.27-.53,1.87-.81q2.74-1.3,5.33-2.78c14.28-8.25,21.42-19.08,21.38-29.9v406.69c0,10.82-7.1,21.65-21.38,29.9-1.71,1-3.5,1.91-5.33,2.78-.6.28-1.24.53-1.86.81-1.09.48-2.16,1-3.28,1.42-.13.06-.27.09-.4.14-2.52,1-5.12,1.85-7.78,2.63-.22.06-.41.15-.63.21-.61.17-1.25.29-1.87.46-1.48.39-3,.77-4.5,1.1-.4.09-.79.21-1.2.29-.6.13-1.21.21-1.81.32-1.27.24-2.55.47-3.83.67-.52.08-1,.19-1.55.27s-1.14.12-1.71.19c-1.2.15-2.4.28-3.61.4-.58.06-1.16.15-1.74.19s-1.08,0-1.63.09c-1.22.09-2.44.15-3.66.2-.62,0-1.23.08-1.85.1s-1,0-1.49,0c-1.32,0-2.64,0-4,0-.66,0-1.33,0-2,0-.39,0-.78-.06-1.17-.08-1.64-.07-3.26-.19-4.89-.32-.66-.06-1.32-.07-2-.13-.21,0-.41-.07-.61-.09q-4.17-.43-8.24-1.15l-.41,0c-.8-.15-1.57-.35-2.36-.51-1.34-.27-2.67-.53-4-.85-1-.23-1.91-.51-2.86-.77-1.26-.34-2.51-.68-3.73-1.06-.27-.09-.54-.15-.8-.23-.45-.15-.85-.34-1.29-.49q-2.92-1-5.7-2.16c-.69-.29-1.39-.58-2.07-.88a75.42,75.42,0,0,1-6.84-3.46l-.89-.53c-.67-.4-1.24-.83-1.87-1.25-.89-.57-1.79-1.14-2.61-1.74s-1.36-1.06-2-1.6-1.53-1.21-2.23-1.84c-.14-.13-.31-.24-.45-.37s-.48-.54-.75-.81a43,43,0,0,1-3.08-3.31c-.2-.24-.47-.47-.67-.72s-.32-.5-.5-.74c-.62-.84-1.18-1.68-1.7-2.53-.22-.36-.51-.71-.72-1.06-.1-.19-.16-.37-.25-.55-.41-.75-.74-1.51-1.07-2.26-.19-.45-.44-.88-.61-1.32-.06-.15-.08-.3-.13-.45-.26-.72-.43-1.45-.62-2.18-.13-.48-.32-1-.42-1.45,0-.13,0-.27-.05-.4-.14-.76-.19-1.52-.26-2.28,0-.5-.16-1-.17-1.49,0-.21,0-.42,0-.64V860.37C382.43,861.08,382.55,861.79,382.61,862.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M403.85,830.44c-28.43,16.41-28.58,43-.34,59.44s74.19,16.41,102.62,0,28.54-43,.29-59.42S432.24,814.05,403.85,830.44Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-79"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M415.74,644.26c0,.41.06.82.14,1.23s.16.68.25,1,.2.79.34,1.18.27.64.4,1,.36.83.58,1.23.35.58.53.87a16.54,16.54,0,0,0,.92,1.38c.2.26.42.53.64.79a21.21,21.21,0,0,0,1.66,1.79c.22.22.42.43.65.64s.8.67,1.22,1,.7.59,1.09.87.94.63,1.42.94,1,.66,1.49,1a40.26,40.26,0,0,0,3.71,1.88c.37.17.75.32,1.13.48,1,.42,2,.81,3.08,1.17.38.13.75.27,1.14.39.66.21,1.34.39,2,.58.52.14,1,.29,1.55.41.71.18,1.44.32,2.16.47.5.1,1,.21,1.5.3,1.47.26,3,.47,4.47.62.47.05.94.08,1.41.12.88.07,1.76.14,2.65.18l1.71,0c.72,0,1.43,0,2.15,0s1.2,0,1.81,0,1.32-.06,2-.1l1.83-.15,1.95-.22,1.77-.25c.7-.11,1.39-.23,2.08-.36l1.63-.33c.83-.19,1.64-.39,2.44-.6l1.36-.37c1.44-.42,2.85-.89,4.22-1.42.67-.27,1.33-.56,2-.85.33-.15.68-.28,1-.44,1-.47,2-1,2.89-1.5,7.74-4.48,11.61-10.35,11.59-16.21V848.74c0,5.86-3.85,11.73-11.59,16.21-.93.53-1.9,1-2.89,1.5-.33.16-.67.29-1,.44-.59.26-1.17.54-1.78.78l-.21.07c-1.37.53-2.78,1-4.22,1.42l-.34.12-1,.25c-.8.21-1.61.41-2.44.6-.22,0-.43.11-.65.16s-.66.1-1,.17c-.69.13-1.38.25-2.08.36l-.84.14c-.31,0-.62.07-.93.11l-1.95.22c-.32,0-.63.08-.94.1s-.59,0-.89.05c-.66,0-1.32.08-2,.1-.34,0-.67.05-1,.06s-.53,0-.8,0c-.72,0-1.43,0-2.15,0h-1.08l-.63,0c-.89,0-1.77-.11-2.65-.18l-1.08-.07-.33,0c-1.5-.15-3-.36-4.47-.62l-.22,0c-.43-.08-.85-.19-1.28-.27-.73-.15-1.45-.29-2.16-.47-.52-.12-1-.27-1.55-.41-.68-.19-1.36-.37-2-.58l-.44-.12c-.24-.08-.45-.19-.69-.27q-1.59-.54-3.09-1.17c-.38-.16-.76-.31-1.13-.48-1.28-.58-2.53-1.19-3.71-1.87l-.48-.29c-.36-.22-.67-.45-1-.68s-1-.62-1.42-.94-.73-.58-1.1-.87-.83-.66-1.21-1c-.07-.07-.16-.13-.24-.2s-.26-.29-.41-.44a21.21,21.21,0,0,1-1.66-1.79c-.11-.13-.26-.26-.37-.39s-.17-.27-.27-.4a16.54,16.54,0,0,1-.92-1.38c-.12-.19-.28-.38-.39-.57s-.09-.2-.14-.3c-.22-.4-.4-.81-.58-1.22-.1-.24-.24-.48-.33-.72,0-.08,0-.16-.07-.24-.14-.39-.23-.79-.34-1.18s-.17-.53-.23-.79c0-.07,0-.14,0-.21-.08-.42-.1-.83-.14-1.24s-.09-.54-.09-.81c0-.11,0-.23,0-.35V643.1A11.35,11.35,0,0,0,415.74,644.26Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M427.25,626.88c-15.41,8.9-15.49,23.33-.18,32.23s40.22,8.89,55.64,0,15.47-23.32.16-32.22S442.65,618,427.25,626.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M230.9,346.77c-.39-3-.58-5.94-.87-8.91-.21-2.11-.47-4.23-.63-6.34-.49-6.66-.81-13.27-.79-19.79.16-56.39,20.08-96.08,52.2-114.75l59.6-34.64c-32.12,18.67-52,58.36-52.2,114.76,0,6.51.3,13.13.8,19.79.16,2.09.41,4.21.62,6.32.51,5.17,1.08,10.36,1.88,15.59.16,1,.3,2.06.47,3.1,1,6.05,2.21,12.14,3.57,18.24.68,3.05,1.48,6.11,2.24,9.16,1.07,4.25,2.16,8.49,3.4,12.74.72,2.47,1.49,4.94,2.26,7.41q2.25,7.17,4.8,14.3c.7,2,1.38,3.95,2.12,5.91,2.47,6.58,5.08,13.14,7.91,19.64.33.76.7,1.51,1,2.27,2.57,5.82,5.31,11.6,8.16,17.33q1.33,2.7,2.72,5.37,4.17,8.12,8.7,16.08c.59,1,1.15,2.1,1.75,3.14,3.6,6.21,7.37,12.31,11.26,18.32,1.14,1.75,2.32,3.45,3.48,5.18q4.32,6.48,8.86,12.77,2.46,3.4,5,6.76c2.63,3.49,5.33,6.9,8,10.28,2.3,2.87,4.62,5.72,7,8.5,4.16,4.9,8.35,9.75,12.7,14.38l.21.21c4.37,4.66,8.89,9.08,13.43,13.43,2,1.91,4,3.79,6.06,5.64,3.32,3,6.7,6,10.1,8.83,2,1.71,4.07,3.43,6.14,5.08,3.7,3,7.46,5.74,11.25,8.47,1.81,1.3,3.59,2.68,5.41,3.93,5.62,3.86,11.3,7.52,17.07,10.84,3.81,2.2,7.58,4.2,11.34,6.1,1.07.54,2.15,1,3.22,1.57q4.31,2.09,8.55,3.91c1,.42,2,.87,3,1.28,2.66,1.09,5.3,2.08,7.91,3,.66.23,1.32.51,2,.73q4.88,1.66,9.65,3c1.87.52,3.72,1,5.56,1.38.87.21,1.75.45,2.62.64,2.72.59,5.42,1.09,8.08,1.5,4.07.63,8,1,12,1.2.79,0,1.58.1,2.37.13,3.52.12,7,.11,10.37-.09.59,0,1.16-.11,1.74-.15q4.11-.31,8.1-.95c.82-.13,1.65-.25,2.47-.4,3-.57,6-1.22,8.94-2.07.13,0,.25-.08.37-.12,2.77-.81,5.46-1.79,8.09-2.85.77-.31,1.52-.64,2.28-1,2.25-1,4.46-2.06,6.61-3.23.7-.39,1.43-.72,2.12-1.12h0l-59.6,34.64-1,.56c-.38.21-.78.36-1.16.57q-3.23,1.75-6.6,3.22c-.42.19-.81.43-1.23.6s-.71.24-1.06.38c-2.64,1.06-5.32,2-8.08,2.85l-.31.11h-.06c-2.91.84-5.9,1.5-8.94,2.06-.36.07-.69.18-1.05.24s-1,.1-1.44.17q-4,.63-8.07.95c-.44,0-.85.12-1.3.15h-.46c-3.39.2-6.85.21-10.37.09-.34,0-.67,0-1,0s-.91-.11-1.36-.13c-3.92-.22-7.89-.58-12-1.2h0c-2.66-.41-5.34-.92-8.06-1.5-.86-.19-1.74-.43-2.61-.64-1.69-.39-3.37-.76-5.07-1.23l-.49-.15c-3.19-.88-6.4-1.86-9.66-3-.64-.22-1.3-.49-2-.72-2.62-.93-5.26-1.92-7.92-3-.35-.15-.69-.25-1-.4-.64-.27-1.3-.61-1.94-.89q-4.25-1.82-8.55-3.9c-1.07-.52-2.14-1-3.21-1.57-3.76-1.9-7.53-3.9-11.35-6.1-5.76-3.33-11.44-7-17.07-10.84-1.82-1.26-3.6-2.63-5.41-3.94-3.78-2.73-7.54-5.51-11.25-8.47-2.06-1.65-4.09-3.36-6.13-5.08q-5.12-4.27-10.1-8.82c-2-1.86-4.06-3.73-6.07-5.65-1.25-1.2-2.54-2.3-3.78-3.52q-4.89-4.83-9.65-9.9l-.21-.21q-4.92-5.25-9.69-10.73c-1-1.18-2-2.45-3-3.64-2.37-2.79-4.68-5.64-7-8.51-1.5-1.87-3.08-3.64-4.55-5.54-1.2-1.54-2.32-3.17-3.5-4.74-1.69-2.24-3.35-4.49-5-6.77-1.13-1.56-2.31-3.06-3.42-4.64-1.86-2.66-3.62-5.4-5.43-8.11-1.16-1.73-2.35-3.44-3.48-5.19-.47-.73-1-1.43-1.45-2.16q-4.77-7.47-9.24-15.14c-.2-.34-.38-.69-.57-1-.6-1-1.15-2.07-1.74-3.11-2.06-3.63-4.14-7.25-6.09-10.93-.91-1.71-1.74-3.45-2.62-5.17s-1.83-3.58-2.73-5.38c-.77-1.56-1.61-3.1-2.37-4.67-2-4.19-3.91-8.42-5.78-12.65-.34-.76-.71-1.51-1-2.27-.09-.21-.2-.41-.29-.62q-3.47-8-6.56-16.05c-.38-1-.7-2-1.07-3-.73-2-1.41-3.94-2.12-5.92-1-2.67-2-5.33-2.87-8-.7-2.09-1.26-4.18-1.92-6.27-.78-2.48-1.54-4.94-2.26-7.42-.45-1.52-1-3-1.39-4.55-.76-2.73-1.32-5.46-2-8.19-.77-3.06-1.57-6.11-2.25-9.16-.23-1.06-.55-2.13-.78-3.19-1.07-5-2-10-2.78-15-.17-1-.32-2.07-.47-3.11C231.57,351.21,231.19,349,230.9,346.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M626.88,541.67c0-6.29-.24-12.65-.61-19-.08-1.32-.15-2.64-.24-4-.45-6.23-1-12.51-1.85-18.82-.22-1.75-.49-3.5-.74-5.25-.41-2.94-.84-5.88-1.33-8.84-.33-2-.7-4-1.06-6-.52-2.85-1.06-5.7-1.65-8.56-.32-1.6-.68-3.21-1-4.81q-2.39-11-5.37-21.92c-.34-1.23-.7-2.45-1-3.68-1.79-6.31-3.7-12.61-5.78-18.91-.15-.47-.29-.94-.45-1.41-2-6.11-4.25-12.2-6.55-18.27-.58-1.53-1.17-3.05-1.77-4.58q-3-7.71-6.29-15.39c-.33-.77-.64-1.55-1-2.32-2.46-5.65-5-11.26-7.71-16.84-.71-1.48-1.44-2.95-2.16-4.43Q577,352,573.59,345.44c-.7-1.34-1.39-2.69-2.11-4q-4.4-8.22-9.08-16.3c-.6-1-1.23-2.05-1.83-3.08q-4.14-7-8.49-13.89c-.85-1.34-1.69-2.69-2.54-4q-5.41-8.4-11.1-16.57c-.58-.83-1.18-1.64-1.77-2.47q-6-8.41-12.19-16.53c-.55-.72-1.09-1.45-1.64-2.16q-7.85-10.09-16.13-19.64c-.73-.84-1.44-1.7-2.17-2.54q-5.12-5.85-10.37-11.48c-.17-.18-.33-.37-.5-.54-3.67-3.92-7.41-7.72-11.18-11.47-.81-.8-1.64-1.57-2.45-2.37q-7.37-7.19-15-13.94c-.47-.4-.92-.83-1.37-1.23-5.25-4.61-10.6-9-16-13.24l-3.08-2.42q-8-6.14-16.13-11.71c-1-.66-1.95-1.3-2.93-1.95-5.7-3.8-11.44-7.46-17.26-10.82-4.67-2.69-9.29-5.14-13.89-7.46-1.34-.68-2.66-1.31-4-2q-5.25-2.55-10.43-4.77c-1.23-.53-2.47-1.09-3.7-1.59-3.27-1.34-6.51-2.56-9.74-3.71-.77-.27-1.57-.6-2.34-.86q-6-2.06-11.84-3.65c-2.3-.64-4.56-1.17-6.83-1.7-1.06-.25-2.14-.55-3.19-.78-3.34-.72-6.65-1.34-9.92-1.84-5-.77-9.85-1.2-14.66-1.47-1-.05-1.94-.12-2.9-.16-4.31-.15-8.56-.14-12.71.11-.72,0-1.43.13-2.16.19-3.35.25-6.65.64-9.89,1.15-1,.17-2,.32-3,.51a111.71,111.71,0,0,0-10.95,2.52l-.5.16c-3.37,1-6.65,2.19-9.87,3.49-.94.38-1.87.78-2.8,1.19q-4.14,1.8-8.1,4c-.86.47-1.76.88-2.61,1.37l59.6-34.64,1.2-.68c.46-.26.95-.44,1.42-.69,2.63-1.44,5.33-2.75,8.09-4,.52-.22,1-.52,1.5-.73s.88-.29,1.3-.46c3.23-1.3,6.5-2.49,9.88-3.49l.41-.14.08,0c3.56-1,7.23-1.83,10.95-2.52.44-.08.84-.22,1.28-.3s1.18-.11,1.76-.2q4.86-.78,9.9-1.16c.54,0,1.05-.15,1.59-.19.18,0,.38,0,.57,0,4.15-.24,8.39-.26,12.7-.1.42,0,.82,0,1.24,0s1.12.13,1.67.16c4.8.27,9.67.71,14.66,1.47h0c3.26.51,6.56,1.13,9.89,1.84,1.06.23,2.13.53,3.19.78,2.07.48,4.13.94,6.22,1.51.2,0,.41.13.61.19q5.86,1.6,11.85,3.65c.77.26,1.56.59,2.34.87,3.22,1.14,6.47,2.36,9.74,3.7.44.18.85.31,1.29.49.78.33,1.6.76,2.39,1.1q5.19,2.22,10.45,4.77c1.32.64,2.65,1.27,4,2,4.61,2.32,9.23,4.77,13.9,7.46,5.82,3.36,11.57,7,17.26,10.82l2.94,2c5.44,3.71,10.81,7.63,16.12,11.71,1,.8,2.06,1.61,3.09,2.42,5.39,4.25,10.74,8.63,16,13.24.46.4.91.83,1.37,1.24,5.06,4.48,10,9.14,14.95,13.93.5.49,1,.93,1.53,1.42.31.31.61.65.93,1q5.65,5.61,11.17,11.46c.17.18.33.37.5.54q5.26,5.63,10.36,11.47c.33.37.66.72,1,1.09s.8,1,1.21,1.47q8.26,9.57,16.12,19.63l.46.56c.41.52.78,1.07,1.18,1.6q6.24,8.1,12.18,16.52c.41.57.84,1.1,1.24,1.67.19.27.36.56.55.82q5.7,8.16,11.09,16.56c.34.53.71,1,1.05,1.57.52.81,1,1.64,1.49,2.45q4.35,6.87,8.48,13.87c.44.75.92,1.48,1.36,2.23l.5.88q4.68,8.07,9.07,16.29c.23.44.49.87.73,1.31.48.89.9,1.81,1.38,2.72q3.43,6.56,6.68,13.19c.45.92,1,1.82,1.39,2.74.27.55.5,1.12.77,1.68,2.67,5.59,5.26,11.2,7.71,16.85.08.17.16.34.23.51.26.58.47,1.18.73,1.76,2.2,5.13,4.29,10.28,6.31,15.44.32.83.69,1.65,1,2.48s.49,1.39.75,2.09c2.31,6.08,4.52,12.16,6.56,18.27,0,.11.08.23.12.34.12.36.21.71.33,1.07,2.08,6.3,4,12.61,5.77,18.91.22.8.5,1.58.72,2.38.13.43.2.86.32,1.3q3,11,5.38,21.92c.14.65.34,1.3.48,1.95.2.95.35,1.91.55,2.86.58,2.86,1.12,5.71,1.64,8.56q.55,3,1.07,6c.49,2.94.91,5.87,1.33,8.81.19,1.39.45,2.8.63,4.19.05.37.06.73.11,1.09q1.19,9.46,1.84,18.8c.09,1.34.17,2.66.24,4,.38,6.39.63,12.75.61,19-.19,69.16-24.61,117.82-64,140.7l-59.6,34.64C602.27,659.49,626.68,610.82,626.88,541.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M188.29,288.45c-.42,139.13,97.43,308.68,218.61,378.63s219.6,13.74,220-125.39c.14-44.37-9.74-91.89-27.19-138.22a528,528,0,0,0-90.35-153.64c-30.14-35.61-64.56-65.68-101-86.77C287.19,93.1,188.71,149.25,188.29,288.45Zm40.3,23.27c.21-64.62,26.35-107.24,67-121.47,30.77-10.86,69.95-5.4,112.56,19.21,98.83,57,178.74,195.41,178.39,309-.14,47-14,82.43-37.29,103.74-32.8,30.13-84.39,32-142.22-1.41C308.14,563.7,228.31,425.34,228.59,311.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M258.45,293.85c-.35,113.62,79.48,252,178.38,309,42.55,24.53,81.66,30.07,112.43,19.28,23.27-21.31,37.15-56.71,37.29-103.74.35-113.55-79.56-251.91-178.39-309-42.61-24.61-81.79-30.07-112.56-19.21C272.4,211.49,258.59,246.89,258.45,293.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M1879.76,721.86l-375-215.16c-32-18.39-96.47,5.42-96.47,42.36l24.48,221.36a90.23,90.23,0,0,0,45.33,78.26l67.74,38.87,15.23,200.6,32.49-15.44,84.61-109.23,165.63,120.4c25.91,14.87,73.84-20.22,73.84-50.09V787.34A75.49,75.49,0,0,0,1879.76,721.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M1847.27,737.3l-375-215.17c-32-18.38-72,4.75-72,41.69v222a90.23,90.23,0,0,0,45.32,78.26L1513.4,903l47.71,185.16,84.61-109.23,181.27,104c25.91,14.87,58.21-3.84,58.21-33.71V802.78A75.5,75.5,0,0,0,1847.27,737.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1634.91,845l-20.51-11.21q.15-22.14.64-27.35a20.93,20.93,0,0,1,3.07-9.29,12.88,12.88,0,0,1,5.76-5.41c2.14-.85,7.2-1.35,15.17-1.46q13-.18,17.88-1.56c3.27-.91,6.13-3.1,8.54-6.57s3.64-8.05,3.64-13.75q0-16.25-11.75-31.92A86.09,86.09,0,0,0,1629.64,712q-31.89-17.43-41.86,9.75c-1.62,4.4-7.15,4.44-12.55.34h0c-6.31-4.81-10-13.4-8.13-18.54q13.89-38.09,63.68-10.87,28.5,15.57,46,40.74T1694.32,783q0,31.75-36.47,30.78-16-.32-19.51,2.51c-2.39,1.88-3.57,6.19-3.57,12.93Zm4.84,33.9v6.29c0,6-4.87,8.23-10.89,4.94l-7-3.82c-6-3.29-10.89-10.83-10.89-16.84v-6.29c0-6,4.88-8.22,10.89-4.94l7,3.82C1634.88,865.3,1639.75,872.84,1639.75,878.85Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInquiryIcon);
export default __webpack_public_path__ + "static/media/NoInquiryIcon.725de5fe8dc6898d5f59b46dc39d1007.svg";
export { ForwardRef as ReactComponent };